module.exports = __webpack_public_path__ + "static/media/earth.795cba62.svg";